import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    stepContent: {
      type: String,
    },
    info: {
      type: Boolean,
    },
    alert: {
      type: Boolean,
    },
  },
  methods: {
    handleClick(event: any) {
      if (event.target.id === 'modalLink') {
        this.$emit('openModal');
      }
    },
  },
});
